module.exports = __webpack_public_path__ + "static/media/payment-type.8ac76723.jpg";